import { motion, useTransform } from 'motion/react'
import styled from 'styled-components'

import { CircularLoader } from '@blade/ui-kit'

import type { MotionValue } from 'motion/react'

type PullToRefreshLoaderProps = {
  height: number
  opacity: MotionValue<number>
  progress: MotionValue<number>
  pulling: boolean
}

export const PullToRefreshLoader: React.FC<PullToRefreshLoaderProps> = ({
  height,
  opacity,
  pulling,
  progress,
}) => {
  const rotation = useTransform(() => -progress.get() * 180)

  return (
    <Root style={{ opacity, scale: opacity, height }}>
      <Wrapper layout style={{ rotate: rotation }}>
        <CircularLoader spinning={pulling ? 'normal' : 'none'} size={24} />
      </Wrapper>
    </Root>
  )
}

const Root = styled(motion.div)`
  inset: 0 0 auto 0;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  padding-top: var(--safe-top);
`

const Wrapper = styled(motion.div)`
  display: flex;
`
